import styled from 'styled-components';
import CloseIconSVG from './close-icon.svg';

const CloseIcon = styled(CloseIconSVG as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2rem'};
  height: ${props => props.height || '2rem'};
  fill: ${props => props.fill || '#647a97'};
  padding: ${props => props.padding || ''};
`;

export default CloseIcon;

